import NodeHelper from '../../../helpers/node_helper'
import AbstractField from '../abstract'

import './style.css'

class SwitchField extends AbstractField{
    __init_dom_schema(){
        return {
            input: {
                selector: 'input[type="checkbox"]',
                // actions: {
                //     'change': this.changed.bind(this)
                // }
            },
            switch: {
                selector: '.js-switch',
                actions: {
                    'click': this.onSwitchClick.bind(this)
                }
            }
        }
    }
    __init(){
        this.registerEvents('changed')
    }
    onSwitchClick(event){
        let is_active = NodeHelper.ToggleClass(
            this.dom.switch, 
            '-active'
        )
        // console.log()

        this.setValue(is_active)
        this.dispatchEvent('changed')
    }
    isRequired(){
        return this.dom.input.hasAttribute('required')
    }
    isFilled(){
        return this.dom.input.checked
    }
    getValue(){
        return this.dom.input.checked
    }
    setValue(value){
        // console.log(this, value)
        // this.dom.input.checked = value
        // if(value !== null){
            
        // }
        NodeHelper.ToggleClass(
                this.dom.switch, 
                '-active',
                value
            )

        NodeHelper.ToggleClass(
                this.dom.switch, 
                '-half-active',
                value === null
            )

        this.dom.input.checked = value
    }
}

export default SwitchField